export enum PageOption {
    DEFAULT = "default",
    DOCUMENTS = 'DOCUMENTS',
    VALIDATE_DOCUMENTS = 'VALIDATE DOCUMENTS',
    DOCUMENT_RUNNER = 'DOCUMENT RUNNER',
    EXPORT = 'EXPORT TO TITLE BANK',
    DOWNLOAD = 'DOWNLOAD',
    IMPORT = 'IMPORT FROM TITLE BANK',
    VIEW_PDF = 'VIEW PDF',
    COMMENTS = 'COMMENTS',
    SPLIT_PDF = 'SPLIT PDF',
    SPLIT_WITH_AI = 'SPLIT WITH AI',
    ASSIGN_USERS = 'ASSIGN USERS',
    INVOICES = 'INVOICES',
    REPORTS = 'REPORTS',
    LINE_LIST_REPORTS = 'LINE LIST'
}
